<script>
import axios from 'axios';
export default {
  props: {user: {type: Object, required: true}},
  data() { return {entries: [], error: '', loaded: false}; },
  methods: {
    async load() {
      try {
        const actor = JSON.parse(localStorage.getItem('user'));
        const {data} = await axios.get(`${process.env.VUE_APP_API}api/v1/admin/payment-review/user/${this.user.uuid}`, {
          headers: {Accept: 'application/json', Authorization: `Bearer ${actor.access_token}`}
        });
        this.entries = data.data; this.loaded = true;
      } catch (_) { this.error = 'Não foi possível consultar as ocorrências.'; }
    }
  }
};
</script>
<template>
  <b-alert show variant="danger" v-if="user.wallet && user.wallet.payment_review_required">
    <strong>Carteira bloqueada por estorno ou contestação.</strong>
    <p>Saques e pagamentos com saldo estão bloqueados até revisão financeira. O saldo histórico foi preservado; não representa valor liberado.</p>
    <b-button size="sm" variant="outline-danger" @click="load">Consultar ocorrências</b-button>
    <p v-if="error">{{error}}</p>
    <ul v-if="loaded">
      <li v-for="(entry, index) in entries" :key="index">
        {{entry.description}} — {{entry.parcel_number ? 'Parcela ' + entry.parcel_number : 'Entrada'}}
        <div v-for="(event, key) in entry.events" :key="key">{{event.event_type}} — {{event.status}}</div>
      </li>
    </ul>
  </b-alert>
</template>
